module.exports = "/_next/static/images/SubjectRightsManagement@3x-31db1adad4cdb743db6dd3e3bdba6d33.webp";